import React from 'react'

import { ZariContext } from '_zari/context'

import { Portlet, Table, Button } from '_zari/core'

import { IdGen } from 'utils'

import * as glosasService from 'services/glosasContabilidad.service'

import * as Modals from './modals'

const GlosaLista = () => {
  const __zariContext = React.useContext(ZariContext)

  const [mostrarNuevoModal, setMostrarNuevoModal] = React.useState(false)
  const [mostrarEditarModal, setMostrarEditarModal] = React.useState(false)

  const tablaRef = React.useRef(null)
  const editarData = React.useRef(null)

  const clickEditar = React.useCallback(
    ({ _id }) => {
      glosasService
        .get(_id)
        .then(({ data }) => {
          editarData.current = {
            ...data,
            _id: _id
          }
          setMostrarEditarModal(true)
        })
        .catch(({ data: { error } }) => __zariContext.snack('error', error))
    },
    [__zariContext]
  )

  const clickEliminar = React.useCallback(
    ({ _id }) => {
      glosasService
        .eliminar(_id)
        .then(() => {
          __zariContext.snack('success', 'El registro se ha eliminado.')
          tablaRef.current.reload()
        })
        .catch(({ data: { error } }) => __zariContext.snack('error', error))
    },
    [__zariContext]
  )

  return (
    <>
      <Portlet>
        <Portlet.Header title='Glosa'>
          <Button onClick={e => setMostrarNuevoModal(true)}>Nuevo</Button>
        </Portlet.Header>
        <Portlet.Body>
          <Table.ServerSide
            useNest={true}
            ref={tablaRef}
            url='/glosas-contabilidad'
            headRows={[{ label: 'NOMBRE' }, { label: '' }]}
            rowTemplate={row => (
              <Table.Row key={IdGen.newId()}>
                <Table.Cell>{row.nombre || '--'}</Table.Cell>
                <Table.Cell>
                  <Table.Dropdown>
                    {({ handleClose }) => [
                      <Table.Dropdown.Item
                        key='editar'
                        handleClose={handleClose}
                        onClick={e => clickEditar({ _id: row._id })}
                      >
                        Editar
                      </Table.Dropdown.Item>,
                      <Table.Dropdown.Item
                        key='eliminar'
                        handleClose={handleClose}
                        onClick={e => clickEliminar({ _id: row._id })}
                      >
                        Eliminar
                      </Table.Dropdown.Item>
                    ]}
                  </Table.Dropdown>
                </Table.Cell>
              </Table.Row>
            )}
          />
        </Portlet.Body>
      </Portlet>
      {mostrarNuevoModal && (
        <Modals.NuevoModal
          handleClose={e => setMostrarNuevoModal(false)}
          show={mostrarNuevoModal}
          reloadTable={tablaRef.current.reload}
        />
      )}
      {mostrarEditarModal && (
        <Modals.EditarModal
          handleClose={e => setMostrarEditarModal(false)}
          show={mostrarEditarModal}
          reloadTable={tablaRef.current.reload}
          modalData={editarData.current}
        />
      )}
    </>
  )
}

export default GlosaLista
